import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function ResendIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      width={width || 20.355}
      height={height || 19.5}
      viewBox="0 0 20.355 19.5"
    >
      <path
        data-name="Path 1060"
        d="M395.615 182.465L391.6 197.7a1.65 1.65 0 01-.81 1.178 1.619 1.619 0 01-1.42.089l-4.793-1.578-1.477 2.021a1.627 1.627 0 01-2.936-.976v-2.883l-3.874-1.615a1.644 1.644 0 01-.193-2.933l17.1-10.208a1.632 1.632 0 012.418 1.67zm-1.61-.253l-17.1 10.211 3.654 1.523 10.168-8.309a.545.545 0 01.8.724l-7.752 8.924 6.213 2.169zm-10.978 14.531l-1.241-.515v2.206z"
        fill={color || "#bbb"}
        transform="translate(-375.28 -180.574)"
      />
    </svg>
  );
}
